import { FlowChartAttachment } from './FlowChartAttachment'
import { FlowChartBlock, FlowChartBlockType } from './FlowChartBlock'
import { FlowChartButton } from './FlowChartButton'
import { FlowChartImagePreview } from './FlowChartImagePreview'

export enum EmailContentType {
  TEXT = 'text',
  BUTTON = 'button',
  ATTACHMENT = 'attachment',
  PREVIEW = 'preview',
}

export interface EmailContent {
  id: string
  type: EmailContentType
  data: object
}

export interface EmailContentText extends EmailContent {
  type: EmailContentType.TEXT
  data: {
    text: string
    buttons: FlowChartButton[]
  }
}

export interface EmailContentButton extends EmailContent {
  type: EmailContentType.BUTTON
  data: {
    button: FlowChartButton
  }
}

export enum EmailContentAttachmentSize {
  S = 'S',
  M = 'M',
  L = 'L',
  FULL = 'FULL',
  ORIGINAL = 'ORIGINAL',
}

export interface EmailContentAttachment extends EmailContent {
  type: EmailContentType.ATTACHMENT
  data: {
    attachment: FlowChartAttachment
    size: EmailContentAttachmentSize
    buttons: FlowChartButton[]
  }
}

export interface EmailContentPreview extends EmailContent {
  type: EmailContentType.PREVIEW
  data: {
    preview: FlowChartImagePreview
    size: EmailContentAttachmentSize
    buttons: FlowChartButton[]
  }
}

export interface FlowChartEmailContentBlock extends FlowChartBlock {
  type: FlowChartBlockType.EMAIL_CONTENT
  data: {
    sender: string
    subject: string
    preheader: string
    content: EmailContent[]
  }
}
